import { FieldInput } from "@/components/form/field-input";

interface BuildingFormFieldsProps {
  isDisabled?: boolean;
}

export function BuildingFormFields({
  isDisabled = false,
}: BuildingFormFieldsProps) {
  return (
    <>
      <FieldInput
        name="categoryBizpass"
        label="Category Bizpass"
        isDisabled={isDisabled}
        hasRequiredAsterisk={!isDisabled}
      />
      <FieldInput
        name="dwellingType"
        label="Dwelling Type"
        isDisabled={isDisabled}
        hasRequiredAsterisk={!isDisabled}
      />
    </>
  );
}
